import React from 'react';

export function addPropsToChildren(extraProps: any, children: any) {
    //use React's .toArray to guarantee an array, even if its a single child
    let childrenArray: React.ReactElement[] = React.Children.toArray<any>(children);
    
    //create a new array so we can change things, since props are immutable
    let childrenWithExtraProps = [];
    
    for (let child of childrenArray) {
        const extendedChild = React.cloneElement(child, extraProps, ...child.props.children);
        childrenWithExtraProps.push(extendedChild)
    }

    return childrenWithExtraProps;
}